import { render, staticRenderFns } from "./CopyrightLinks.vue?vue&type=template&id=d54a9142"
import script from "./CopyrightLinks.vue?vue&type=script&lang=js"
export * from "./CopyrightLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports